// removed by extract-text-webpack-plugin
module.exports = {"block":"Card__block___1XduG","faceup":"Card__faceup___3j8aw","flipper":"Card__flipper___1YM5b","front":"Card__front___2wjI2","back":"Card__back___2zorJ","matched":"Card__matched___1vB14","a":"Card__a___3v7GQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Card.css
// module id = 105
// module chunks = 0